import styled from 'styled-components';

export const GuarnateesModalInfortuniStyles = styled.div`
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  @media only screen and (max-width: 900px) {
    overflow-y: auto;
  }
`;

export const GuaranteesModalBody = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 50px;
`;

export const GuaranteesModalHeader = styled.div`
  padding: 20px 30px;
  background: var(--grey-light-0, #fff);
  box-shadow: 0px 5.69277px 0px 0px rgba(46, 53, 85, 0.04);
  border-top-right-radius: 50px;
  border-top-left-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: 900px) {
    flex-direction: column;
    padding: 15px 20px;
  }
`;

export const GuaranteesLeftSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 60px;
  margin: 10px 0;
  margin-left: 10px;
`;
export const GuaranteesRightSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 30px;
  margin-right: 5%;

  @media only screen and (max-width: 900px) {
    margin-right: 0;
  }
`;

export const GuaranteesTextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  @media only screen and (max-width: 900px) {
    p {
      font-size: 14px;
    }
  }
`;
export const GuaranteesTitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 10px;

  h3 {
    margin-bottom: 0;
    color: var(--grey-dark-6, #1a1921);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 79.699px */
  }

  p {
    color: var(--grey-dark-2, #616d87);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 26.566px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 39.849px */
    margin-bottom: 0;
  }

  img {
    max-width: 30px;
  }

  @media only screen and (max-width: 900px) {
    h3 {
      font-size: 18px;
    }
  }
`;

export const BackButton = styled.button`
  background: #8bd4b347;
  border: 1px solid #8bd4b347;
  border-radius: 50px;
  color: #00a651;
  text-align: center;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  min-width: 150px;
  padding: 10px 30px;
  transition: all 300ms ease-in-out;

  &:hover {
    background: #00a651;
    border: 1px solid #00a651;
    border-radius: 50px;
    color: #ffffff;
  }

  @media only screen and (max-width: 900px) {
    font-size: 14px;
    min-width: 170px;
    width: 100%;
    padding: 8px 20px;
  }
`;

export const AddButton = styled.button`
  background: #00a651;
  border: 1px solid #00a651;
  border-radius: 50px;
  color: #ffffff;
  text-align: center;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  min-width: 150px;
  padding: 10px 30px;
  transition: all 300ms ease-in-out;

  &:hover {
    background: #8bd4b347;
    border: 1px solid #8bd4b347;
    border-radius: 50px;
    color: #00a651;
  }

  @media only screen and (max-width: 900px) {
    font-size: 14px;
    min-width: 170px;
    width: 100%;
    padding: 8px 20px;
  }
`;

export const GuaranteesModalContent = styled.div`
  padding: 20px 30px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
  flex-direction: column;
  max-width: 800px;
  margin: 30px auto;

  @media only screen and (max-width: 900px) {
    margin: 10px auto;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  cursor: pointer;
  max-width: 800px;
  margin-bottom: 20px;

  @media only screen and (max-width: 900px) {
    margin-bottom: 10px;
  }
`;

export const InputCircle = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  border: 2px solid #00a651;

  &.selected {
    background-color: #00a651;
  }

  @media only screen and (max-width: 900px) {
    width: 20px;
    height: 20px;
  }
`;

export const InputText = styled.h5`
  color: #343434;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  margin-bottom: 0;

  @media only screen and (max-width: 900px) {
    font-size: 16px;
  }
`;
